import { UContainer } from '@src/components'

import { SigninMain } from './signin-main'

export const SigninPage = () => {
  return (
    <UContainer maxWidth="lg">
      <SigninMain />
    </UContainer>
  )
}
